import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Notification {
    id: number;
    title: string;
    date: string;
    content: string;
}

const initialState = {
    notifications: [
        {
            id: 1,
            title: '[직원초대]',
            date: '22.12.01 13:00',
            content: '이하나님의 승인이 완료되었습니다.',
        },
        {
            id: 2,
            title: '[직원초대]',
            date: '22.12.01 13:00',
            content: '김진우님의 승인이 완료되었습니다.',
        },
    ],
};

export const sideNavSlice = createSlice({
    name: 'notificationState',
    initialState,
    reducers: {
        removeNotification: (state, action: PayloadAction<{ id: number }>) => {
            const filteredNotifications: Notification[] = state.notifications.filter(
                (notification: Notification) => notification.id != action.payload.id,
            ); 
            state.notifications = filteredNotifications;
        },
        removeAllNotifications: (state) => {
            state.notifications = [];
        },
    },
});

export const { removeNotification, removeAllNotifications } = sideNavSlice.actions;
export default sideNavSlice.reducer;
